import React, { useEffect, useState } from 'react';
import classes from './ProfilePage2.module.css';
import { getProfileApi } from '../../http/http'; 
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { removeUserDetails } from '../../store/slices/userSlice';
import Header2 from '../../component/NewComponents/Header2';
import { FaFutbol, FaArrowRightFromBracket, FaPen } from 'react-icons/fa6';

const ProfilePage2 = () => {
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const { userDetails } = useSelector(state => state.persisted?.userSlice);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const fetchUserProfile = async () => {
        try {
            setLoading(true);
            const response = await getProfileApi(userDetails?.token);
            setProfile(response?.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(
                error?.response?.data?.error?.error ||
                error?.response?.error?.error ||
                error?.response?.error ||
                'Something Went Wrong!'
            );
        }
    };

    useEffect(() => {
        fetchUserProfile();
    }, []);

    const logoutHandler = () => {
        dispatch(removeUserDetails());
        navigate('/');
    };

    return (
        <div className={classes.page}>
            <Header2 active={4} />

            <main className={classes.main}>

                {/* ── Hero bar ── */}
                <div className={classes.heroBar}>
                    <div className={classes.heroText}>
                        <span className={classes.heroEyebrow}>Your Account</span>
                        <h1 className={classes.heroTitle}>My <em>Profile</em></h1>
                    </div>
                    <div className={classes.heroMeta}>
                        <span className={classes.profileChip}>
                            <FaFutbol className={classes.chipIcon} />
                            Player
                        </span>
                    </div>
                </div>

                {/* ── Body ── */}
                <div className={classes.body}>

                    {/* ── Profile card ── */}
                    <div className={classes.profileCard}>
                        <div className={classes.cardBg} />

                        <div className={classes.avatarWrap}>
                            {loading ? (
                                <div className={classes.avatarSkeleton} />
                            ) : profile?.image ? (
                                <img src={profile.image} alt={profile?.name || 'User'} className={classes.avatarImg} />
                            ) : (
                                <div className={classes.avatarFallback}>
                                    <span className={classes.avatarInitials}>
                                        {profile?.name
                                            ? profile.name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()
                                            : '?'}
                                    </span>
                                </div>
                            )}
                            <div className={classes.avatarRing} />
                        </div>

                        <div className={classes.cardInfo}>
                            {loading ? (
                                <>
                                    <div className={classes.skeletonName} />
                                    <div className={classes.skeletonSub} />
                                </>
                            ) : (
                                <>
                                    <p className={classes.cardName}>{profile?.name || 'Guest'}</p>
                                    <p className={classes.cardSub}>Joined &amp; ready to play</p>
                                </>
                            )}
                        </div>
                    </div>

                    {/* ── Menu groups ── */}
                    <div className={classes.menuGroups}>

                        <div className={classes.group}>
                            <span className={classes.groupLabel}>Account</span>
                            <div className={classes.menuCard}>
                                <button
                                    type="button"
                                    className={classes.menuItem}
                                    onClick={() => navigate('/edit-profile')}
                                >
                                    <div className={`${classes.iconBox} ${classes.iconBlue}`}>
                                        <FaPen className={classes.itemIcon} />
                                    </div>
                                    <div className={classes.itemText}>
                                        <span className={classes.itemTitle}>Edit Profile</span>
                                        <span className={classes.itemSub}>Update your info &amp; photo</span>
                                    </div>
                                    <span className={classes.chevron}>›</span>
                                </button>

                                <div className={classes.menuDivider} />

                                <button
                                    type="button"
                                    className={classes.menuItem}
                                    onClick={() => navigate('/my-matches')}
                                >
                                    <div className={`${classes.iconBox} ${classes.iconGreen}`}>
                                        <FaFutbol className={classes.itemIcon} />
                                    </div>
                                    <div className={classes.itemText}>
                                        <span className={classes.itemTitle}>My Matches</span>
                                        <span className={classes.itemSub}>View your match history</span>
                                    </div>
                                    <span className={classes.chevron}>›</span>
                                </button>
                            </div>
                        </div>

                        <div className={classes.group}>
                            <span className={classes.groupLabel}>Session</span>
                            <div className={classes.menuCard}>
                                <button
                                    type="button"
                                    className={classes.menuItem}
                                    onClick={logoutHandler}
                                >
                                    <div className={`${classes.iconBox} ${classes.iconRed}`}>
                                        <FaArrowRightFromBracket className={classes.itemIcon} />
                                    </div>
                                    <div className={classes.itemText}>
                                        <span className={`${classes.itemTitle} ${classes.logoutTitle}`}>Logout</span>
                                        <span className={classes.itemSub}>Sign out of your account</span>
                                    </div>
                                    <span className={classes.chevron}>›</span>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>

            </main>
        </div>
    );
};

export default ProfilePage2;